module.exports = __webpack_public_path__ + "img/default_shop_banner_sm.42c28867.jpg";